/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack5';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import fileFill from '@iconify/icons-eva/file-fill';
import plusFill from '@iconify/icons-eva/plus-circle-outline';
import forwardFill from '@iconify/icons-eva/arrow-forward-outline';
import trash2Fill from '@iconify/icons-eva/download-outline';
import * as XLSX from 'xlsx';
import FilePreview from 'src/components/common-components/FilePreview';
/* eslint-disable import/no-unresolved */

import { getProjectListByClient, resetProjectListByClient } from 'src/redux/slices/client';
import { getCategoryListByProject, resetCategoryListByProject } from 'src/redux/slices/filecategory';

// material
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  Typography,
  FormHelperText,
  Autocomplete,
  Button,
  styled,
  List,
  ListItemText,
  ListItemIcon,
  ListItem,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from '@material-ui/core';
import { updateExclusionRuleSet, getParticularExclusionRule } from 'src/redux/slices/exclusionrules';
import { useDispatch, useSelector } from 'react-redux';
import { varFadeInRight } from 'src/components/animate';
import FullDialog from 'src/components/common-components/FullDialog';
import { AnimatePresence, motion } from 'framer-motion';
import { LoadingButton } from '@material-ui/lab';
import axios from 'axios';
import {
  uploadExcelFile,
  resetUploadedFile,
  collectionApplyRule,
  resetAppliedRuleFile,
  getColumnOptionSuccess,
  resetColumnOption,
  resetCollectionError,
  resetSuccess,
  checkColumnMapData,
  resetCheckColumnMapStatus
} from '../../../redux/slices/collection';
import { fData } from '../../../utils/formatNumber';
import { MIconButton } from '../../@material-extend';
import { UploadSingleFile } from '../../upload';
import { PATH_DASHBOARD } from '../../../routes/paths';
import ExclusionRuleList from './ExclusionRuleList';
import Processing from './Processing';
import SaveCollectionRuleDialog from './SaveCollectionRuleDialog';
import CollectionRuleDialog from './CollectionRuleDialog';

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1)
}));

const previewColumnFile = ({ Data }) => (
  <TableContainer sx={{ minWidth: 800, overflow: 'scroll', height: 450 }}>
    <Table stickyHeader sx={{ border: 1 }}>
      <TableBody>
        {Data?.map((Dataa, index) => (
          <TableRow sx={{ bgcolor: index % 2 === 0 ? '#3cb37117' : 'white', border: 1 }} key={index}>
            {Dataa?.map((temp, tempIndex) => (
              <TableCell sx={{ border: 1 }} key={tempIndex}>
                {temp}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

CollectionDataForm.propTypes = {
  SELECT_FILE_OPTION: PropTypes.array
};

export default function CollectionDataForm({ SELECT_FILE_OPTION }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { exclusionRulesSetData, particularExclusionRuleData } = useSelector((state) => state.exclusionrules);
  const {
    excelUpload,
    errorMsg,
    isError,
    isSuccess,
    successMsg,
    appliedRuleFile,
    isLoading,
    isLoadingFile,
    checkColumnMapStatus,
    checkColumnMapMsg
  } = useSelector((state) => state.collection);
  const { clientList, checkProjectLinked, projectListByClient } = useSelector((state) => state.client);
  const { categoryListByProject, checkCategoryLinked } = useSelector((state) => state.filecategory);
  const [preview, setPreview] = useState('');
  const [xlsTableData, setXlsTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [fileRequired, setFileRequired] = useState(true);
  const [disableUpload, setDisableUpload] = useState(false);
  const [checkModal, setCheckModal] = useState(false);
  const [applyRule, setApplyRule] = useState(false);
  const [data, setData] = useState(null);
  const [exclusionRuleId, setExclusionRuleId] = useState('');
  const [exclusionRules, setExclusionRules] = useState([]);
  const [fileSize, setFileSize] = useState('');

  const NewUserSchema = Yup.object().shape({
    client: Yup.mixed().required('Client is required'),
    project: Yup.mixed().required('Project is required'),
    scoringModel: Yup.mixed().required('scoringModel is required'),
    cover: fileRequired ? Yup.mixed().required('File is required') : ''
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: '',
      project: '',
      scoringModel: '',
      fileCategory: null,
      fileManager: null,
      cover: null
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const formData = new FormData();
        formData.append('client', values.client.id);
        formData.append('project', values.project.id);
        formData.append(
          fileRequired ? 'excel_file' : 'master_file',
          fileRequired ? values.cover : values.fileManager.id
        );
        dispatch(uploadExcelFile(formData));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, setFieldValue } = formik;

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setPreview(file.path);
        setFileSize(fData(file?.size));
        setFieldValue('cover', file);
        handleXlsFilePreview(file);
        setDisableUpload(false);
      }
    },
    [setFieldValue]
  );

  const handleXlsFilePreview = async (file) => {
    const data = await file.arrayBuffer();
    const workBook = XLSX.read(data);
    const workSheets = workBook.Sheets[workBook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(workSheets, {
      header: 1,
      defval: ''
    });
    setXlsTableData(jsonData);
  };

  const handleCancel = () => {
    setCheckModal(false);
    setDisableUpload(false);
    setApplyRule(false);
    setFieldValue('cover', null);
    setPreview('');
    dispatch(resetUploadedFile());
  };

  const handleContinue = () => {
    setCheckModal(false);
    setApplyRule(true);
    setData(excelUpload);
    dispatch(getColumnOptionSuccess(excelUpload?.required_columns));
    dispatch(resetUploadedFile());
  };

  const handleSelectExclusionRule = (id) => {
    dispatch(resetAppliedRuleFile());
    setExclusionRuleId(id);
    if (!particularExclusionRuleData[id]) {
      if (id) {
        dispatch(getParticularExclusionRule(id));
      }
    }
  };

  const updateExclusionRule = () => {
    dispatch(updateExclusionRuleSet(exclusionRules, exclusionRuleId));
  };

  const handleApplyRule = () => {
    if ((values?.cover || values?.fileManager) && exclusionRules.length > 0) {
      const obj = {
        file: data?.file,
        client: values?.client.id,
        project: values?.project.id,
        rules: exclusionRules
      };
      dispatch(collectionApplyRule(obj));
    } else if (!values?.cover && !values?.fileManager) {
      enqueueSnackbar('File is not uploaded yet please select or upload', {
        variant: 'error'
      });
    } else if (exclusionRules.length === 0) {
      enqueueSnackbar('Create new rules or select from saved ones', {
        variant: 'error'
      });
    }
  };

  useEffect(() => {
    if (values?.client?.id && values?.project?.id) {
      const data = {
        project: values?.project.id,
        client: values?.client.id
      };
      dispatch(checkColumnMapData(data));
    }
  }, [values?.client?.id, values?.project?.id]);

  useEffect(() => {
    if (!checkColumnMapStatus && checkColumnMapMsg) {
      setDisableUpload(true);
    } else {
      setDisableUpload(false);
    }
  }, [checkColumnMapStatus, checkColumnMapMsg]);

  useEffect(() => {
    if (excelUpload) {
      setDisableUpload(true);
      setCheckModal(true);
      setData(null);
      setApplyRule(false);
      dispatch(resetAppliedRuleFile());
    }
  }, [excelUpload]);

  useEffect(() => {
    if (isSuccess && successMsg) {
      enqueueSnackbar(successMsg, {
        variant: 'success'
      });
      setFileSize('');
      setXlsTableData([]);
      dispatch(resetSuccess());
      getFilePreview(appliedRuleFile?.file);
    } else if (isError && errorMsg) {
      enqueueSnackbar(errorMsg, {
        variant: 'error'
      });
      dispatch(resetCollectionError());
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    dispatch(resetAppliedRuleFile());
    dispatch(resetColumnOption());
    dispatch(resetCheckColumnMapStatus());
  }, []);

  const downloadMasterFile = (fileName) => {
    const outputFilename = 'MasterFile';
    const link = document.createElement('a');
    link.href = fileName;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const getFilePreview = (file) => {
    let masterFile;
    if (file) {
      axios({
        url: file,
        method: 'GET',
        responseType: 'blob'
      }).then((blob) => {
        masterFile = new File([blob.data], file?.substring(file?.lastIndexOf('/') + 1), {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        setFileSize(fData(masterFile?.size));
        handleXlsFilePreview(masterFile);
      });
    }
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card sx={{ p: 3 }}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <Autocomplete
                      name="client"
                      disablePortal
                      fullWidth
                      value={values?.client ? values?.client : ''}
                      options={clientList}
                      onChange={(e, value) => {
                        setFieldValue('project', '');
                        setFieldValue('fileCategory', '');
                        setFieldValue('client', value);
                        dispatch(resetCategoryListByProject());
                        if (value) {
                          dispatch(getProjectListByClient(value.id));
                        } else {
                          dispatch(resetProjectListByClient());
                        }
                      }}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => (option ? option?.client_name : '')}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean(
                            (touched.client && errors.client) || checkProjectLinked || checkCategoryLinked
                          )}
                          helperText={(touched.client && errors.client) || checkProjectLinked}
                          required
                          {...params}
                          label="For Client"
                          margin="none"
                        />
                      )}
                    />
                    <Autocomplete
                      fullWidth
                      name="project"
                      disablePortal
                      value={values.project ? values.project : ''}
                      options={projectListByClient}
                      onChange={(e, value) => {
                        setFieldValue('fileCategory', '');
                        setFieldValue('project', value);
                        if (value) {
                          dispatch(getCategoryListByProject(value.id));
                        } else {
                          dispatch(resetCategoryListByProject());
                        }
                      }}
                      getOptionLabel={(option) => (option ? option?.project_name : '')}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean((touched.project && errors.project) || checkCategoryLinked)}
                          helperText={(touched.project && errors.project) || checkCategoryLinked}
                          required
                          {...params}
                          label="For Project"
                          margin="none"
                        />
                      )}
                    />
                  </Stack>

                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <Autocomplete
                      fullWidth
                      name="fileCategory"
                      value={values.fileCategory ? values.fileCategory : null}
                      onChange={(e, value) => setFieldValue('fileCategory', value)}
                      options={categoryListByProject}
                      getOptionLabel={(option) => (option ? option?.category_name : '')}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean(touched.fileCategory && errors.fileCategory)}
                          helperText={touched.fileCategory && errors.fileCategory}
                          required
                          {...params}
                          label="File Type"
                          margin="none"
                        />
                      )}
                    />
                    <Autocomplete
                      fullWidth
                      disablePortal
                      value={values?.fileManager ? values?.fileManager : null}
                      name="fileManager"
                      options={SELECT_FILE_OPTION}
                      onChange={(e, value) => {
                        if (value) {
                          setFileRequired(false);
                        } else {
                          setFileRequired(true);
                        }
                        setFieldValue('fileManager', value);
                        setPreview(value?.file_name);
                        getFilePreview(value?.master_file);
                      }}
                      getOptionLabel={(option) => (option ? option.file_name : '')}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      renderInput={(params) => <TextField {...params} label="Select From File Manager" margin="none" />}
                    />
                  </Stack>

                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                    <Autocomplete
                      fullWidth
                      disablePortal
                      value={values?.scoringModel ? values?.scoringModel : ''}
                      name="scoringModel"
                      options={['Not applicable']}
                      onChange={(e, value) => setFieldValue('scoringModel', value)}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderInput={(params) => (
                        <TextField
                          error={Boolean(touched.scoringModel && errors.scoringModel)}
                          helperText={touched.scoringModel && errors.scoringModel}
                          required
                          {...params}
                          label="Select Scoring Model"
                          margin="none"
                        />
                      )}
                    />
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 3, sm: 2 }}
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    {!values?.fileManager && (
                      <Box>
                        <div>
                          <LabelStyle>Upload File*</LabelStyle>
                          <UploadSingleFile
                            maxSize={2000000}
                            accept=".xlsx"
                            file={values.cover}
                            onDrop={handleDrop}
                            error={Boolean(touched.cover && errors.cover)}
                          />
                          {touched.cover && errors.cover && (
                            <FormHelperText error sx={{ px: 2 }}>
                              {touched.cover && errors.cover}
                            </FormHelperText>
                          )}
                        </div>
                      </Box>
                    )}
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 3, sm: 2 }}
                    justifyContent="space-evenly"
                    alignItems="center"
                  >
                    {preview && (
                      <List disablePadding>
                        <AnimatePresence>
                          <ListItem
                            component={motion.div}
                            {...varFadeInRight}
                            sx={{
                              my: 1,
                              py: 0.75,
                              px: 2,
                              borderRadius: 1,
                              color: (theme) => `${theme.palette.primary.main}`,
                              border: (theme) => `solid 1px ${theme.palette.primary.main}`,
                              bgcolor: 'background.paper'
                            }}
                          >
                            <ListItemIcon>
                              <Icon icon={fileFill} color="inherit" width={28} height={28} />
                            </ListItemIcon>
                            <ListItemText
                              primary={preview}
                              secondary={fData(fileSize)}
                              primaryTypographyProps={{ variant: 'subtitle2' }}
                              secondaryTypographyProps={{ variant: 'caption' }}
                            />
                            <MIconButton
                              onClick={() => {
                                setPreview('');
                                setFieldValue('cover', null);
                                setFieldValue('fileManager', null);
                                dispatch(resetUploadedFile());
                                setFileRequired(true);
                                setXlsTableData([]);
                              }}
                              edge="end"
                              size="small"
                            >
                              <Icon icon={closeFill} />
                            </MIconButton>
                          </ListItem>
                        </AnimatePresence>
                      </List>
                    )}
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      sx={{ justifyContent: 'end', alignItems: 'center' }}
                    >
                      <Button variant="outlined" type="button" onClick={() => setOpen(true)}>
                        Preview
                      </Button>
                      <LoadingButton
                        disabled={disableUpload}
                        variant="contained"
                        loading={isLoadingFile}
                        type="submitt"
                        //
                      >
                        Upload
                      </LoadingButton>
                    </Stack>
                  </Stack>

                  {applyRule && disableUpload && (
                    <Card sx={{ p: 3, overflow: 'visible' }}>
                      <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography variant="h6"> Filtering Rules: </Typography>
                          <CollectionRuleDialog
                            dialogTitle="Add Filtering Rule"
                            icon={plusFill}
                            setExclusionRules={setExclusionRules}
                          />
                        </Stack>
                        <Stack
                          sx={{ width: '50%' }}
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                          alignItems="center"
                        >
                          <Autocomplete
                            fullWidth
                            options={exclusionRulesSetData}
                            onChange={(e, value) => {
                              handleSelectExclusionRule(value?.id);
                            }}
                            getOptionLabel={(option) => option.exclusion_rule_name}
                            renderInput={(params) => (
                              <TextField {...params} label="select from saved rules" margin="none" />
                            )}
                          />
                        </Stack>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <ExclusionRuleList
                            selectedExclusionRuleId={parseInt(exclusionRuleId, 10)}
                            setExclusionRules={setExclusionRules}
                            exclusionRules={exclusionRules}
                          />
                        </Stack>

                        <Stack
                          sx={{ justifyContent: 'space-between' }}
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {exclusionRules.length > 0 && (
                              <div>
                                <SaveCollectionRuleDialog
                                  btnName="Save"
                                  title="Save New Filtering Rule"
                                  exclusionRules={exclusionRules}
                                  projectName={values?.project}
                                />

                                {particularExclusionRuleData[exclusionRuleId]?.rules && (
                                  <>
                                    <Button
                                      variant="outlined"
                                      onClick={updateExclusionRule}
                                      sx={{ marginLeft: '10px' }}
                                    >
                                      Update
                                    </Button>
                                  </>
                                )}
                              </div>
                            )}
                          </Stack>
                          <LoadingButton
                            type="button"
                            variant="outlined"
                            loading={isLoading}
                            // disabled={appliedRuleFile || exclusionRules?.length === 0}
                            onClick={() => handleApplyRule()}
                          >
                            Apply Rule
                          </LoadingButton>
                        </Stack>
                      </Stack>
                    </Card>
                  )}

                  {/* <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <FullWidthDialog dialogTitle="Processing" btnName="Run scoring" ComponentCalled={Processing} />
                  </Box> */}
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    {appliedRuleFile && (
                      <Box marginRight="3rem">
                        <IconButton
                          title="Download Filtered File"
                          onClick={() => {
                            if (appliedRuleFile) downloadMasterFile(appliedRuleFile?.file);
                          }}
                        >
                          <Icon icon={trash2Fill} />
                        </IconButton>
                        <span> No. of Rows : {appliedRuleFile?.total_no_entries}</span>
                      </Box>
                    )}
                    {/* <Button
                      type="button"
                      disabled={!appliedRuleFile}
                      endIcon={<Icon icon={forwardFill} />}
                      variant="contained"
                      onClick={() => navigate(PATH_DASHBOARD.general.segmentation)}
                    >
                      Segmentation
                    </Button> */}
                    <FullDialog
                      nextButton
                      nextButtonTitle="Proceed for Segmentation"
                      data={xlsTableData}
                      CalledComponent={previewColumnFile}
                      btnName="Segmentation"
                      endIcon={forwardFill}
                    />
                  </Box>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>

      <FilePreview
        formik={formik}
        openPreview={open}
        onClosePreview={() => setOpen(false)}
        CalledComponent={previewColumnFile}
        showableContent={xlsTableData}
      />
      <Dialog open={checkModal} onClose={() => setCheckModal(true)} maxWidth="sm" fullWidth>
        <DialogTitle>Processing</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <Processing
            setCheckModal={setCheckModal}
            handleContinue={handleContinue}
            handleClose={handleCancel}
            data={applyRule ? data : excelUpload}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
